import createDataStoreReducer from '../../../modules/utilities/store/slices/dataStore/reducer'
import DATA_STORE_TYPES from '../../../modules/utilities/store/slices/dataStore/types'

export const ZONE_DEVICE_DATA_STORE_SLICE_NAME = 'zoneDevicesStore'
export const zoneDeviceDataStoreTypes = DATA_STORE_TYPES(ZONE_DEVICE_DATA_STORE_SLICE_NAME)

const bucketToJSON = bucket => {
  if (!Array.isArray(bucket)) {
    return bucket
  }
  return bucket.map(item => (item && typeof item.toJSON === 'function' ? item.toJSON() : item))
}

/**
 * Zone assignments are stored as arrays keyed by zoneId. lodash merge (default data-store MERGE)
 * merges arrays by index, so refetches after assign/unassign leave stale rows. Replace each zone bucket on MERGE.
 */
export const createZoneDeviceDataStoreReducer = types => {
  const baseReducer = createDataStoreReducer(types)

  return (state = {}, action) => {
    if (action.type === types.MERGE) {
      const incoming = action.data?.data ?? {}
      const next = { ...state }
      for (const zoneId of Object.keys(incoming)) {
        next[zoneId] = bucketToJSON(incoming[zoneId])
      }
      return next
    }
    return baseReducer(state, action)
  }
}

export default createZoneDeviceDataStoreReducer(zoneDeviceDataStoreTypes)
